@if (antiFraudConfig) {
<tec-modal
    [isVisible]="true"
    [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.TITLE' | translate"
    [buttonPrimaryLabel]="'BUTTON.SAVE' | translate"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    (closeEvent)="closeModal()"
>
    <span>{{ 'WORKFLOWS.DETAIL.ANTIFRAUD_DESCRIPTION' | translate }}</span>

    <!-- TABS -->
    <tec-tabs [tabs]="tabs" />

    <!-- TAB: FOTOCOPIA -->
    @if (tabs.length && tabs[0].selected) {
    <div class="item-group">
        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.FINISH_PROCESS' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.photocopy_check?.blocking_step ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.photocopy_check?.blocking_step ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_IP' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.photocopy_check?.ip_block ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.photocopy_check?.ip_block ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_ID' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.photocopy_check?.identifier_block ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.photocopy_check?.identifier_block ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL' | translate"
            [tagImage]="{ icon: 'icon-mail', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${!!antiFraudConfig?.photocopy_check?.email_alert ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="!!antiFraudConfig?.photocopy_check?.email_alert ? 'success' : 'disabled'"
            />

            <span>{{ antiFraudConfig?.photocopy_check?.email_alert }}</span>
        </tec-item>
    </div>
    }

    <!-- TAB: FOTO -->
    @if (tabs.length && tabs[1].selected) {
    <div class="item-group">
        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.FINISH_PROCESS' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.screen_photo?.blocking_step ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.screen_photo?.blocking_step ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_IP' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.screen_photo?.ip_block ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.screen_photo?.ip_block ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_ID' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.screen_photo?.identifier_block ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.screen_photo?.identifier_block ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL' | translate"
            [tagImage]="{ icon: 'icon-mail', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${!!antiFraudConfig?.screen_photo?.email_alert ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="!!antiFraudConfig?.screen_photo?.email_alert ? 'success' : 'disabled'"
            />

            <span>{{ antiFraudConfig?.screen_photo?.email_alert }}</span>
        </tec-item>
    </div>
    }

    <!-- TAB: IMAGEN MANIPULADA -->
    @if (tabs.length && tabs[2].selected) {
    <div class="item-group">
        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.FINISH_PROCESS' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.manipulated_photo?.blocking_step ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.manipulated_photo?.blocking_step ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_IP' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.manipulated_photo?.ip_block ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.manipulated_photo?.ip_block ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_ID' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.manipulated_photo?.identifier_block ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.manipulated_photo?.identifier_block ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL' | translate"
            [tagImage]="{ icon: 'icon-mail', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${!!antiFraudConfig?.manipulated_photo?.email_alert ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="!!antiFraudConfig?.manipulated_photo?.email_alert ? 'success' : 'disabled'"
            />

            <span>{{ antiFraudConfig?.manipulated_photo?.email_alert }}</span>
        </tec-item>
    </div>
    }

    <!-- TAB: IDENTIFICADOR BLOQUEADO -->
    @if (tabs.length && tabs[3].selected) {
    <div class="item-group">
        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.FINISH_PROCESS' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.identifier_blocked?.blocking_step ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.identifier_blocked?.blocking_step ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_IP' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.identifier_blocked?.ip_block ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.identifier_blocked?.ip_block ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_ID' | translate"
            [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${antiFraudConfig?.identifier_blocked?.identifier_block ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="antiFraudConfig?.identifier_blocked?.identifier_block ? 'success' : 'disabled'"
            />
        </tec-item>

        <tec-item
            [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL' | translate"
            [tagImage]="{ icon: 'icon-mail', status: 'notice' }"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${!!antiFraudConfig?.identifier_blocked?.email_alert ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="!!antiFraudConfig?.identifier_blocked?.email_alert ? 'success' : 'disabled'"
            />

            <span>{{ antiFraudConfig?.identifier_blocked?.email_alert }}</span>
        </tec-item>
    </div>
    }
</tec-modal>
}
